import { PkpassBarcodeTypes } from '../../../../types';
export const barcodeTypesValues = {
  [PkpassBarcodeTypes.PKBarcodeFormatAztec]: {
    isSquared: true
  },
  [PkpassBarcodeTypes.PKBarcodeFormatPDF417]: {
    isSquared: false
  },
  [PkpassBarcodeTypes.PKBarcodeFormatQR]: {
    isSquared: true
  },
  [PkpassBarcodeTypes.PKBarcodeFormatCode128]: {
    isSquared: false
  }
};
export const barcodeTypes = barcodeTypesValues;
//# sourceMappingURL=barcode.js.map